import React, { useEffect, useRef } from 'react';
import Label from './fromLabel';
import Error from './fromError';
import Icon from '../../icons';


interface InputProps {
    isMulti?: boolean;
    accept?: string;
    placeholder?: string;
    value?: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    info?: string;
    error?: string;
}

const FileUpload: React.FC<InputProps> = ({ placeholder, value, onChange, disabled = false, label, required, info, error, accept = '*', isMulti = false }) => {

    const inputRef: any = useRef();
    const [imagePreview, setImagePreview] = React.useState<string[]>([]);

    useEffect(() => {
        console.log('image preview', imagePreview);
    }, [imagePreview]);

    useEffect(() => {
        if (Array.isArray(value) || typeof value == 'string') {
            if (inputRef.current) {
                inputRef.current.value = null;
                setImagePreview([]);
            }
        }
    }, [value]);
    return (
        <div className='my-6'>
            {label && <Label text={label} required={required} info={info} />}
            <input
                ref={inputRef}
                type="file"
                multiple={isMulti}
                placeholder={placeholder}
                onChange={(e: any) => {
                    const files = e.target.files

                    if (files) {
                        let preview: any = [];
                        for (let i = 0; i < files.length; i++) {
                            console.log('file type-----', files[i].type);
                            let file = files[i];
                            if (file.type.startsWith('image/')) {
                                let reader: any = new FileReader();
                                reader.onloadend = () => {
                                    preview = [...preview, reader.result];
                                    setImagePreview(preview);
                                };
                                reader.readAsDataURL(file);
                            } else {
                                preview.push('file');
                            }
                        }
                        setImagePreview(preview);
                    }


                    onChange(e);
                }}
                accept={accept}
                disabled={disabled}
                className={`pl-4 py-2  ${error ? 'border-red-500 border-2' : 'border-[#CECECE] border'} rounded-md focus:outline-none  focus:primary text-[0.938rem] mt-2 font-normal min-h-[2.875rem] text-[#656565] w-full placeholder:text-[#656565]`}
            />

            <div className='flex flex-col gap-2 mt-2'>
                {imagePreview.length > 0 ? imagePreview.map((img: any, i: number) => (
                    <>
                        {
                            img != '' && <>
                                {img != 'file' ?
                                    <div key={i} className='w-full h-[150px] rounded-md' style={{ backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                                    :
                                    <div key={i} className='relative' >
                                        <Icon name='file' size={4} className='text-[#656565]' />
                                    </div>
                                }
                            </>
                        }

                    </>
                )) :
                    <>
                        {Array.isArray(value) && value.length > 0 &&
                            value.map((img: any, i: number) => (
                                <>
                                    {typeof img == 'string' &&
                                        <div key={i} className='w-full h-[150px] rounded-md' style={{ backgroundImage: `url(${img})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                                    }
                                </>
                            ))
                        }
                        {typeof value == 'string' && value !== '' &&
                            <div className='w-full h-[150px] rounded-md ' style={{ backgroundImage: `url(${value})`, backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                        }
                    </>
                }

            </div>

            {error && <Error message={error} />}
        </div>
    );
};

export default FileUpload;